import Flickity from "flickity";

require("flickity-sync");
require("flickity-as-nav-for");

class SectorsCarousel {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.carouselElem = self.elem.querySelector('[data-carousel]');
        self.carouselElemNav = self.elem.querySelector('[data-carousel-nav]');
    }

    init() {
        let self = this;

        self.getCarousel();

        window.onresize = function(event) {
            self.getCarousel();
        };
    }

    getCarousel() {
        let self = this;

        const flkty = new Flickity(self.carouselElem, {
            autoPlay: false,
            // wrapAround: true,
            draggable: false,
            prevNextButtons: false,
            pageDots: false,
            fade: true,
            adaptiveHeight: true,
            setGallerySize: true,
            sync: document.querySelector('.carousel--sector-nav'),
            initialIndex: 6
        });

        const flktyNav = new Flickity(self.carouselElemNav, {
            asNavFor: document.querySelector('.carousel--sectors'),
            autoPlay: false,
            // pageDots: false,
            // wrapAround: true,
            prevNextButtons: false
        });

        var previousButton = self.elem.querySelector('[data-carousel-button-previous]');
        var nextButton = self.elem.querySelector('[data-carousel-button-next]');

        previousButton.addEventListener('click', function(cellIndex) {
            flkty.previous();
        });

        nextButton.addEventListener('click', function(cellIndex) {
            flkty.next();
        });

        flktyNav.on('change', function(cellIndex){
            flkty.select(cellIndex);
        });
    }
}

export default SectorsCarousel;
